import React from 'react';
import {OrbitComponent} from '../../../../base-components/orbit-component/orbit-component';
import {Check} from '@sparkware/app-utils';
import {GameDescriptionTextBox} from './boxes/game-description-text/game-description-text.box';
import {SectionTitleBox} from '../../boxes/section-title/section-title.box';

export interface GameAboutTextComponentProps {
  aboutText: string
}

export class GameAboutComponent extends OrbitComponent<GameAboutTextComponentProps> {
  render() {
    if(Check.isEmpty(this.props.aboutText)) {
      return null;
    }

    return (
      <>
        <SectionTitleBox className='cy-game-about-title'>
            {this.services.translation.translate('ABOUT')}
        </SectionTitleBox>
        <GameDescriptionTextBox className='cy-game-about-description'>
          {this.props.aboutText}
        </GameDescriptionTextBox>
      </>
    );
  }
}
